module.exports = __webpack_public_path__ + "img/2.bd98321f.jpg";